import React from 'react'

import { BusinessInfo, ScrollToTopButton } from 'components'

import { MostViewedProjects, UpcomingTours } from 'modules/Feed/containers'
import { TopChartingProductsContainer } from 'modules/Products/containers'
import { StoriesFeed } from 'modules/Feed/containers/StoriesFeed'

const FeedPage = () => (
  <div className="page">
    <div className="sbx-row sbx-row-gutter-20">
      <div className="sbx-col-md-24 sbx-col-md-order-1 sbx-col-lg-13 sbx-col-lg-order-0">
        <StoriesFeed />
      </div>
      <div className="sbx-col-xs-24 sbx-col-xs-order-0 sbx-col-md-24 sbx-col-md-order-0 sbx-col-lg-11 sbx-col-lg-order-1">
        <div style={{ height: 95 }} />
        <TopChartingProductsContainer />
        <UpcomingTours />
        <MostViewedProjects />
        <BusinessInfo />
      </div>
    </div>
    <ScrollToTopButton />
  </div>
)

export default FeedPage
